import phoneCodes from '../../components/phoneCode'

export const phoneCode = {
  components: {
    phoneCodes,
  },
  computed: {
    activeCode() {
      return this.$store.state.activePhoneCode
    },
    minMaskLength() {
      return this.activeCode.mask.replace(/\(|\)|\-/g,'').length
    }
  },
  methods: {
    setActiveCode(code) {
      this.$store.commit('SET_ACTIVE_PHONE_CODE', code)
    }
  }
}
